import {PageFragment} from "shared/PageFragment";
import {PlaceholderFragment} from "../../shared/PlaceholderFragment";

export class HomeFragment extends PageFragment {

  renderContent() {
    return <PlaceholderFragment />;
  }
}
